const ageCalc = () => {
  const ageContainer = document.querySelectorAll('.ftbl__driver-page-info__data#age');

  ageContainer.forEach((container) => {
    if (container && container.textContent) {
      const birthDayPieces = container.textContent
        .replace(/^\s+|\s+$/g, '')
        .trim()
        .split('/')
        .map((v) => parseInt(v, 10));
      const birthDayDate = new Date(birthDayPieces[2], birthDayPieces[1] - 1, birthDayPieces[0]);
      const now = new Date();

      let age = now.getFullYear() - birthDayDate.getFullYear();
      if (
        now.getMonth() < birthDayDate.getMonth() ||
        (now.getMonth() === birthDayDate.getMonth() && now.getDate() < birthDayDate.getDate())
      ) {
        age--;
      }

      container.textContent = `${container.textContent} (${age})`;
    }
  });
};

export default ageCalc;
